import { useQuery } from '@apollo/client';

import { UseLoggedInUserDocument } from './use-logged-in-user-query.gql-types';
import type { UseLoggedInUserXingIdFragment } from './use-logged-in-user-xing-id.fragment.gql-types';

/**
 * @deprecated Use `useLoggedInUser` instead: `import { useViewerData } from '@xing-com/hub';` and `const user = useViewerData().data?.user;`. See also: https://brewery.preview.xing.io/hub#viewer-data
 */
export function useLoggedInUser(): UseLoggedInUserXingIdFragment | undefined {
  const { data } = useQuery(UseLoggedInUserDocument, {
    fetchPolicy: 'cache-first',
  });

  return data?.viewer?.xingId ?? undefined;
}
